module.exports = __webpack_public_path__ + "img/sascha-uhl-informationstechnologie.ed37b18a.jpg";